import * as React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';
import withStyles from '@material-ui/core/styles/withStyles';

import EmailContactSales from '../components/EmailContactSales';
import Layout from '../components/Layout';

import WomanCoinsScreens from '../images/indirect-loans/womanCoinsScreens.svg';
import CoupleHomeLadder from '../images/indirect-loans/coupleHomeLadder.svg';
import HandshakeEsign from '../images/indirect-loans/handshakeEsign.svg';
import PhoneDollar from '../images/indirect-loans/PhoneDollar.svg';
import PhoneSignature from '../images/indirect-loans/PhoneSignature.svg';
import ThreeHeads from '../images/indirect-loans/ThreeHeads.svg';
import circlePurpleMoneyBag from '../images/icons/circle-purple-money-bag.png';
import halfSectionGradient from '../images/indirect-loans/half-section-gradient.png';
import halfSectionWithPattern from '../images/indirect-loans/half-section-with-pattern.png';

import fullWidthSplitBgPurpleWhite from '../images/indirect-loans/fullWidthSplitBgPurpleWhite.png';
import indirectLoansSplash from '../images/indirect-loans/header-gradient.png';

import WantToSeeHow from '../components/WantToSeeHow';

import PhonePlayer from '../components/PhonePlayer';
import PhoneVideoMP4 from '../videos/pos.mp4';
import PhoneVideoWEBM from '../videos/pos.webm';
import posVideoThumbnail from '../images/phone/pos.png';

import leafImageRight from '../images/home/leafRight.png';

const styles = { paper: { margin: '1em', }, };

const Section = styled.section`

	&.the-time h3{
		@media (${(props) => props.theme.largeUp}) {
			max-width: 880px;
		}
	}

	@media (${(props) => props.theme.mediumUp}) {
		&.purpleLeftWhiteRight {
			background-image: ${(props) => `url('${fullWidthSplitBgPurpleWhite}')`};
		}

		&.fund-consumer .text-box header h2 {
			max-width: 60%;
		}

		&.full-width-split .text-box header h2 {
			max-width: 70%;
		}

		&.capture-signatures .text-box header h2 {
			max-width: 70%;
		}
	}

	&.full-width-split figure {
		background-color: #cc806f;
		background-image: ${(props) => `url('${halfSectionWithPattern}')`};

		@media (${(props) => props.theme.mediumUp}) {
			background-image: ${(props) => `url('${halfSectionGradient}')`};
		}

		& .decorationBehindPhone {
			background-image: ${(props) => `url('${leafImageRight}')`};
			background-position: right 70%;
			padding: 0 10%;
			background-size: 50px 100px;
			background-repeat: no-repeat;

			@media (${(props) => props.theme.smallUp}) {
				padding: 0 12%;
				background-size: 99px 199px;
			}

			@media (${(props) => props.theme.mediumUp}) {
				padding: 0 13% 0 0;
				background-size: 80px 160px;
				margin-right: 1em;
			}

			@media (${(props) => props.theme.largeUp}) {
				padding: 0 15% 0 0;
				background-repeat: no-repeat;
				background-size: 99px 199px;
			}
		}
	}
`;

const HeaderContentArticle = styled.article`
	color: white;

	& h1 {
		background-image: none;

		@media (${(props) => props.theme.mediumUp}) {
			background-image: ${(props) => `url('${circlePurpleMoneyBag}')`};
			background-repeat: no-repeat;
			background-position: right center;
			// min-height: 113px;
			width: 270px;
		}

		@media (${(props) => props.theme.largeUp}) {
			width: 320px
		}
	}
`;

const HeaderBottomContentFigure = styled.figure`
	background: transparent;
	margin-bottom: 1em;
`;
interface BusinessCreditCardsProps {
	classes: Record<string, any>;
	data: any;
}

interface BusinessCreditCardsState {
	isDialogOpen: boolean;
}

class BusinessCreditCardsPage extends React.Component<BusinessCreditCardsProps, BusinessCreditCardsState> {
	state = {
		isDialogOpen: false,
	};

	render () {
		const {
			classes,
			data,
			data: {
				site: {
					siteMetadata: { endpoint },
				},
			},
		} = this.props;

		const creditCardsHeaderContent =
			<HeaderContentArticle style={{marginTop: `0px`}}>
				<h1>Indirect<br />Loans</h1>
				<p className='bigger'>Capitalize on growing consumer<br />demand for third-party loans.</p>

				<EmailContactSales />
			</HeaderContentArticle>
		;

		const splashFigure =
			<HeaderBottomContentFigure>
				<CoupleHomeLadder alt='Couple with remodeling blueprint next to a home' />
			</HeaderBottomContentFigure>
		;

		return <Layout
			headerBottomContent={splashFigure}
			headerContent={creditCardsHeaderContent}
			headerSplashBgPositionLarge='bottom center'
			headerSplashBg={indirectLoansSplash}
			headerSplashBgAverageColor={'#cc806f'}
			metaDescription={"MK Decision's indirect loan origination system (ILOS) helps financial institutions issue loans through third party dealers."}
			pageTitle={'Indirect loan origination system | ILOS | mobile friendly and responsive'}
			skipMoney2020={true}
			BodyClass={'ilos UseCases'}
		>
			<div className='centeredWrapper'>
				<Section className='centered-text the-time'>
					<h2>The time is now to enter the indirect loan market</h2>
					{/* <h3>Indirect Loans allow dealer financing through third-party relationship to help improve funding availability and risk management.</h3> */}
				</Section>
				<Section className='fund-consumer row row-flush centered'>
					<article className='col-12 col-md-6'>
						<div className='text-box'>
							<header>
								<ThreeHeads alt='Three consumers' />
								<h2>Fund consumer purchases through third-party dealers</h2>
							</header>
							<p>The indirect lending market continues to increase its momentum with consumers looking for convenient financing for auto purchases and home improvement projects through dealers. Grow your dealer network and capital with efficient integration, effective risk management, ease-of-use, and fast turnaround times.</p>
						</div>
					</article>
					<figure className='col-12 col-md-6'>
						<WomanCoinsScreens alt='Woman holding coins' />
					</figure>
				</Section>
			</div>
			<Section className='full-width-split full-width purpleLeftWhiteRight'>
				<div className='centeredWrapper'>
					<div className='responsivePadding row row-flush'>
						<article className='col-12 col-md-6 right-on-desktop'>
							<div className='text-box'>
								<header>
									<PhoneDollar alt='Loan App' />
									<h2>Empower dealers to finance loans from any mobile device</h2>
								</header>
								<p>Give dealers and contractors the ability to offer their customers fast and convenient financing from anywhere, any time. Fund more loans by putting user-friendly loan applications into the hands of customers whose projects need funding. Mobile responsive interfaces are optimized for over 400 mobile devices, tablets, and home computers.</p>
							</div>
						</article>
						<figure className='col-12 col-md-6 left-on-desktop'>
							<PhonePlayer
								PhoneVideoMP4={PhoneVideoMP4}
								PhoneVideoWEBM={PhoneVideoWEBM}
							/>
						</figure>
					</div>
				</div>
			</Section>
			<div className='centeredWrapper'>
				<Section className='capture-signatures row row-flush centered'>
					<article className='col-12 col-md-6'>
						<div className='text-box'>
							<header>
								<PhoneSignature alt='E-signature' />
								<h2>Capture signatures digitally to streamline customer applications</h2>
							</header>
							<p>MK's Indirect Loan origination system uses E-Signature to mitigate wait times, increase application speed and lower transaction costs. Electronic signatures prevent delays in finalizing loan applications resulting in improved performance and instant approvals. E-signatures offer enhanced security and mitigate risks associated with pen and paper.</p>
						</div>
					</article>
					<figure className='col-12 col-md-6'>
						<HandshakeEsign alt='Homeowner shaking hands with dealer, Esign' />
					</figure>
				</Section>
				<WantToSeeHow />
			</div>
		</Layout>;
	}
}

export default withStyles(styles)(BusinessCreditCardsPage);

export const pageQuery = graphql`
	query {
		site: site {
			siteMetadata {
				endpoint
			}
		}
  	}
`;
